
import RadioGroup from '../components/radio';
import Textarea from '../components/textarea';
import Rating from '../components/rating';
import NumberInput from '../components/number-input';
import TextInput from '../components/text-input';
import PhoneInput from '../components/phone-input';
import PasswordInput from '../components/password-input';
import Select from '../components/select';
import Checkbox from '../components/checkbox';
import DatePicker from '../components/date-picker';
import TimePicker from '../components/time-picker';
import FileUploader from '../components/file-uploader';
import Cards from '../components/cards';
import ControlFactoryProps from './mixins/ControlFactoryProps';
import { ControlEventType, ControlType } from '../enums';
import { ControlFactoryProperty } from './enums';
import Autocomplete from '../components/autocomplete';
import IncrementInput from '../components/increment-input';

export default {
  name: 'ControlFactory',
  mixins: [ControlFactoryProps],
  data() {
    return {
      ControlFactoryProperty,
      ControlEventType,
    };
  },
  methods: {
    getControlComponent(controlType) {
      switch (controlType) {
        case ControlType.Textarea:
          return Textarea;
        case ControlType.Rating:
          return Rating;
        case ControlType.Radio:
          return RadioGroup;
        case ControlType.DatePicker:
          return DatePicker;
        case ControlType.TimePicker:
          return TimePicker;
        case ControlType.FileUploader:
          return FileUploader;
        case ControlType.NumberInput:
          return NumberInput;
        case ControlType.TextInput:
          return TextInput;
        case ControlType.PhoneInput:
          return PhoneInput;
        case ControlType.PasswordInput:
          return PasswordInput;
        case ControlType.Select:
          return Select;
        case ControlType.Checkbox:
          return Checkbox;
        case ControlType.Autocomplete:
          return Autocomplete;
        case ControlType.Cards:
          return Cards;
        case ControlType.IncrementInput:
          return IncrementInput;
        default:
          return TextInput;
      }
    },
    handleChange(value) {
      this.$emit(ControlEventType.Change, value);
    },
    handleBlur(value) {
      this.$emit(ControlEventType.Blur, value);
    },
    handleFocus(value) {
      this.$emit(ControlEventType.Focus, value);
    },
  },
};
